<template>
    <div>
        <div class="table-container" v-bind:class="{ tableEmpty : tab == 0, tableJson: tab == 1 }">
           <div >
    <v-tabs v-model="tab" grow>
        <v-tab name="First tab">
            <v-icon>mdi-map-marker-outline</v-icon>Simple
        </v-tab>

        <v-tab-item >
             <v-expand-transition>
                <ComponenteBusqueda title="Búsqueda" :pendientes="true" @search-query="search" style="margin-top: 5px"/>
            </v-expand-transition>
        </v-tab-item>
        <v-tab name="Second tab">
            <v-icon>mdi-file-outline</v-icon>Múltiple
        </v-tab>
        <v-tab-item>
             <v-expand-transition>
                <ComponenteBusquedaMultiple title="Búsqueda" :pendientes="true" @search-query-json="searchjson" style="margin-top: 5px"/>
            </v-expand-transition>
        </v-tab-item>
    </v-tabs>
</div>
        </div>
        <div class="table-container" v-bind:class="{tableFull: tab == 0, tableFullJson: tab == 1}">
            <v-expand-transition>
                <ComponenteHistorial title="Búsquedas Recientes" :pendientes="false" @recent-query="show"/>
            </v-expand-transition>
        </div>
    </div>
</template>

<script>
import ComponenteBusqueda from '@/components/ListaBusqueda/ComponenteBusqueda/ComponenteBusqueda.vue'
import ComponenteBusquedaMultiple from '@/components/ListaBusqueda/ComponenteBusqueda/ComponenteBusquedaMultiple.vue'
import ComponenteHistorial from '@/components/ListaBusqueda/ComponenteHistorial/ComponenteHistorial.vue'
import {AlertType, AlertStatus} from '@/views/helpers'

import store from '@/store'

export default {
    name: 'LeftBar',
    components:{
        ComponenteBusqueda,
        ComponenteBusquedaMultiple,
        ComponenteHistorial
    },
    data: () => ({
        AlertStatus,
        loadingTable: true,
        tab: null
    }),
    methods:{
        AlarmSelected(value){
            this.$emit('item-selected', value);
        },
        search(value){
            this.$emit('search-query', value);
        },
        searchjson(value){
            this.$emit('search-query-json', value);
        },
        show(value){
            this.$emit('recent-query', value);
        }
    },
    computed:{
      alarmasPendientes(){
          if (!this.$store.state.alarmas){
              return undefined
          }
          else{
            return this.$store.state.alarmas.filter(item => item.status == AlertStatus.PENDING).length
          }               

      },
      alarmasAtencion(){
          if (!this.$store.state.alarmas){
              return undefined
          }
          else{
            return this.$store.state.alarmas.filter(item => item.status == AlertStatus.ATTENDED).length
          }               

      }
    }
}
</script>

<style scoped>
    .table-container {
        display:block;
        overflow-y: hidden;
        padding: 5px;
        height: calc((100vh - (48px  + 30px))/2);
        transition: height .5s;

        /* border: 1px solid var(--v-primaryclear-base) */
    }

    .tableEmpty{
        height: 308px !important;
    }

    .tableJson{
        height: 508px !important;
    }

    .tableFull{
        height: calc((100vh - (48px  + 30px + 308px))) !important;
    }


    .tableFullJson{
        height: calc((100vh - (48px  + 30px + 508px))) !important;
    }

    ::v-deep .theme--light.v-tabs-items{
        background: transparent;
    }

    .v-tab{
        text-transform: none;
    }
</style>